import { UIElementType } from '@ply-io/ply-front-shared-utilities';
import ContextService from './ContextService';

// Private

const getElementDefaultParamsMap = (element, context, isNative) => {
	const contextualRelatedParams = context?.params || {};
	const contextParams = isNative ? {} : getElementContextParams(element, context);
	const testValues = getElementTestValues(element);
	return Object.assign(
		{},
		Object.entries(contextualRelatedParams).reduce((defaults, [key, value]) => ({ ...defaults, [key]: contextParams[value] || '' }), {}),
		testValues.values || {}
	);
};

const getElementContextParams = (element, context, includeTestValue = false) => {
	const SAMPLE_VALUE = 'Sample value';
	const url = element.metadata.created_in || '';
	const hasContext = !!context;
	const testValues = getElementTestValues(element) || {};

	const extraValues = hasContext || includeTestValue ? testValues.values : {}; // If it has context, handle it here. otherwise we'll add a virtual field

	const defaultParams = hasContext
		? Object.values(context.params || {}).reduce((params, param) => ({ ...params, [param]: SAMPLE_VALUE }), {})
		: {};

	return { ...defaultParams, ...extraValues, ...ContextService.extractParamsFromUrl(context, url) };
};

const getElementParamsMap = (element) => element.metadata.paramsMap || {};

const getElementTestValues = (element) => element.metadata.testValues || {};

// Public

const getElementFullParamsMap = (element, context, isNative) =>
	Object.assign({}, getElementDefaultParamsMap(element, context, isNative), getElementParamsMap(element));

const getElementParamsMapLabels = (element) => element.metadata.paramsMapLabels || {};

/**
 * This method returns contextual data from the testValues of an element *THAT DOESNT HAVE A CONTEXT NODE*
 * @param {*} element
 * @returns
 */
const getElementContextualData = (element) => {
	if (!element) {
		return {};
	}
	const testValues = getElementTestValues(element);
	return testValues?.values;
};

const getElementMappedFields = (element, context, isNativeElement, nativeElement, includeTestValue = false) => {
	let elementMappedFields = {};
	if (element) {
		const url = element.metadata.created_in || '';
		if (url) {
			elementMappedFields['url'] = url;
		}

		if (!isNativeElement) {
			elementMappedFields = { ...elementMappedFields, ...getElementContextParams(element, context, includeTestValue) };
		} else {
			elementMappedFields = { ...elementMappedFields, database_id: nativeElement.entity_id, page_id: nativeElement.preview_entity_id };
		}
	}
	return elementMappedFields;
};

export const isTileElement = (elementType) => elementType === UIElementType.Tile;

const ElementService = {
	getElementFullParamsMap,
	getElementParamsMapLabels,
	getElementMappedFields,
	getElementContextualData,
};

export default ElementService;
